export default function duration(value, hyphenate) {
	if (value) {
		const MONTH_PER_YEAR = 12;
		const years = Math.floor(value/MONTH_PER_YEAR),
			months = value % MONTH_PER_YEAR;
		let formattedStr = '';

		if (hyphenate) {
			const yrString = years ? years + '-year' : '';
			const mthString = months ? months + '-month' : '';

			formattedStr = yrString ? yrString : (mthString || '');
		} else {
			const yrString = years ? years + ' year' + (years > 1 ? 's' : '') : '';
			const mthString = months ? months + ' month' + (months > 1 ? 's' : '') : '';

			formattedStr = yrString + (mthString ? ' ' + mthString : '');
		}

		return formattedStr;
	}
}



// WEBPACK FOOTER //
// ./src/filters/duration.js